import React, { useId } from 'react'
import PropTypes from 'prop-types'

const UrlIcon = React.forwardRef(function UrlIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.5C5 6.67157 5.67157 6 6.5 6 7.32843 6 8 6.67157 8 7.5 8 8.32843 7.32843 9 6.5 9 5.67157 9 5 8.32843 5 7.5ZM5 17.5C5 16.6716 5.67157 16 6.5 16 7.32843 16 8 16.6716 8 17.5 8 18.3284 7.32843 19 6.5 19 5.67157 19 5 18.3284 5 17.5ZM13.1843 3.01712C13.7271 3.1189 14.0846 3.64146 13.9829 4.18429L10.9829 20.1843C10.8811 20.7271 10.3585 21.0846 9.81571 20.9829 9.27288 20.8811 8.91534 20.3585 9.01712 19.8157L12.0171 3.81571C12.1189 3.27288 12.6415 2.91534 13.1843 3.01712ZM18.1843 3.01712C18.7271 3.1189 19.0846 3.64146 18.9829 4.18429L15.9829 20.1843C15.8811 20.7271 15.3585 21.0846 14.8157 20.9829 14.2729 20.8811 13.9153 20.3585 14.0171 19.8157L17.0171 3.81571C17.1189 3.27288 17.6415 2.91534 18.1843 3.01712Z"
      ></path>
    </svg>
  )
})

UrlIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

UrlIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default UrlIcon
